import { render, staticRenderFns } from "./default.vue?vue&type=template&id=fcc67078&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=fcc67078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc67078",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheNavbar: require('/Users/yasumura65/Dev/pico/knowledgeloop-trial/components/layouts/TheNavbar.vue').default,Loading: require('/Users/yasumura65/Dev/pico/knowledgeloop-trial/components/layouts/Loading.vue').default,Alert: require('/Users/yasumura65/Dev/pico/knowledgeloop-trial/components/layouts/Alert.vue').default})
